export default "__VITE_ASSET__BdN6R14X__"